import { SkeletonLoader } from "../../../../components";

export const ReceiptTemplateSkeletonLoader = () => {
  const transferHeaderColor = "rgb(214 214 214)";

  return (
    <div
      className="receipt-skeleton"
      style={{
        minWidth: "300px",
        margin: "10px",
        padding: "2px",
        border: "2px solid rgb(214 228 242)",
        borderRadius: "3px",
      }}
    >
      <table style={{ width: "100%", backgroundColor: "rgb(244 244 244)" }}>
        <tbody>
          <tr
            style={{
              backgroundColor: transferHeaderColor,
            }}
          >
            <td style={{ textAlign: "center", padding: "10px 0" }}>
              <img
                src={`${process.env.PUBLIC_URL}/switchapp-logo.svg`}
                alt="switchapp logo"
                className="app-logo"
              />
            </td>
          </tr>

          <tr
            style={{
              backgroundColor: transferHeaderColor,
              fontSize: "12px",
              width: "100%",
            }}
          >
            <td
              style={{
                height: "50px",
                borderBottom: "1px solid lightgray",
                textAlign: "center",
              }}
            >
              <h4
                style={{
                  color: "#6c6464",
                  fontWeight: "bold",
                  padding: "10px 20px",
                }}
              >
                <div className="flex-container justify-content--center">
                  <SkeletonLoader
                    type="placeholder"
                    className="title-skeleton"
                  />
                </div>
              </h4>

              <div className="flex-container justify-content--center mb-5">
                <SkeletonLoader
                  type="placeholder"
                  className="title-amount-skeleton"
                />
              </div>
            </td>
          </tr>

          <tr>
            <td style={{ textAlign: "center" }}>
              <h6 style={{ margin: "20px 0", color: "gray" }}>
                TRANSFER DETAILS
              </h6>
            </td>
          </tr>

          <tr>
            <td>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Sender </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                          }}
                        >
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Reference </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                          }}
                        >
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "24px", paddingRight: 0 }}>
                        <strong>Amount </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                          }}
                        >
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Beneficiary </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Beneficiary Bank</strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>
                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Beneficiary Acct. </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Session Id </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                      borderBottom: "solid .2px rgba(222,221,221,.65)",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Description </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            maxWidth: "250px",
                          }}
                        >
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Transfer Date </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Status </strong>

                        <strong
                          style={{
                            float: "right",
                            marginLeft: "10px",
                          }}
                        >
                          <SkeletonLoader
                            type="placeholder"
                            className="simple-text-skeleton"
                          />
                        </strong>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
